export enum Role {
    Parent = 'parent',
    Admin = 'admin',
    CompanyMember = 'companyMember',
    SchoolSecretary = 'schoolSecretary'
}